import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer } from '@coreui/react-pro'

// routes config
import TermsOfService from '../views/pages/census/components/ConfirmationModals/TermsOfService'
import routes from '../routes'
import Loader from './common/Loader/Loader'
import SidePanel from '../views/pages/SidePanel/SidePanel'
import NoAiValidator from './NoAiValidator'

const AppContent = () => {
  return (
    <CContainer className="p-0">
      <Suspense fallback={<Loader />}>
        <TermsOfService />
        <NoAiValidator />
        <SidePanel />
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="/" element={<Navigate to="login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
